module.exports = __webpack_public_path__ + "img/kitesurf_iniciacion.e5319ea4.jpg";